import type { WorkJourneyRow } from '../api';

type ProjectOption = { id: string; name: string };

/** Find existing task-to-release journeys by their visible work or project identity. */
export function searchCampaignWorkJourneys(
  journeys: WorkJourneyRow[],
  query: string,
  projects: ProjectOption[]
): WorkJourneyRow[] {
  const normalizedQuery = query.trim().toLowerCase();
  const projectNames = new Map(
    projects.map((project) => [project.id, project.name])
  );

  return journeys
    .filter((journey) => {
      if (!normalizedQuery) return true;
      const journeyProjects = journey.projectIds.flatMap((id) => {
        const name = projectNames.get(id);
        return name ? [name] : [];
      });
      const searchable = [
        journey.title,
        ...journey.taskRefs,
        ...journeyProjects,
        ...journey.items.map(
          (item) =>
            `${item.title} ${item.externalRefId} ${item.externalRepo || ''}`
        )
      ]
        .join(' ')
        .toLowerCase();
      return searchable.includes(normalizedQuery);
    })
    .sort(
      (left, right) =>
        Date.parse(right.lastActivityAt) - Date.parse(left.lastActivityAt)
    );
}
